import { InfoTooltip } from '../InfoTooltip.js';
import { METRIC_EXPLANATIONS } from '../../data/metric-explanations.js';

export interface CoreMetric {
  label: string;
  value: string;
  status: 'good' | 'caution' | 'danger' | 'unknown';
  explanation: string;
  tooltipKey?: string;
}

export interface ProCoreMetricsProps {
  metrics: CoreMetric[];
}

const STATUS_COLORS: Record<string, string> = {
  good: '#27ae60',
  caution: '#f39c12',
  danger: '#e74c3c',
  unknown: '#95a5a6',
};

const STATUS_LABELS: Record<string, string> = {
  good: 'Low Risk',
  caution: 'Caution',
  danger: 'High Risk',
  unknown: 'Unknown',
};

export function ProCoreMetrics({ metrics }: ProCoreMetricsProps) {
  if (metrics.length === 0) return null;

  return (
    <div className="pro-core-metrics">
      <div className="pro-core-metrics-header">
        <h2 className="pro-core-metrics-title">Core Safety Metrics</h2>
        <p className="pro-core-metrics-subtitle">Key indicators explained in plain English</p>
      </div>
      <div className="pro-core-metrics-grid">
        {metrics.map((m, i) => {
          const color = STATUS_COLORS[m.status] ?? STATUS_COLORS.unknown;
          const statusLabel = STATUS_LABELS[m.status] ?? STATUS_LABELS.unknown;
          const tooltipExplain = m.tooltipKey ? METRIC_EXPLANATIONS[m.tooltipKey] : undefined;

          return (
            <div
              key={i}
              className="pro-core-metric-card"
              style={{ borderLeftColor: color }}
            >
              <div className="pro-core-metric-top">
                <span className="pro-core-metric-label">
                  {m.label}
                  {tooltipExplain && <InfoTooltip explain={tooltipExplain} compact />}
                </span>
                <span
                  className="pro-core-metric-status"
                  style={{ color, borderColor: color }}
                >
                  {statusLabel}
                </span>
              </div>
              <div className="pro-core-metric-value" style={{ color }}>
                {m.value}
              </div>
              <p className="pro-core-metric-explain">{m.explanation}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
